module.exports = __webpack_public_path__ + "img/test freeze.f32fcb49.png";